export const FETCH_WAIT_LIST_DATA = "FETCH_WAIT_LIST_DATA";
